import Vue from 'vue/dist/vue.js';
import Timeline from '../vue/timeline.vue';
import Stickyfill from 'stickyfill';
import 'promise-polyfill/src/polyfill';

// JavaScript to be fired on the Timeline Archive
jQuery('.timeline-container').each(function() {
	var timelineContainerId = '#' + jQuery(this).attr('id');
	var componentIndex = jQuery(this).data('component');
	var pageId = jQuery(this).data('page');

	new Vue({
		el: timelineContainerId,
		components: {
			Timeline,
		},
		data: {
			pageId: pageId,
			containerId: timelineContainerId,
			componentIndex: componentIndex,
		},
	});
});

let stickyElements = document.querySelectorAll('.sticky');

for (var i = stickyElements.length - 1; i >= 0; i--) {
	Stickyfill.add(stickyElements[i]);
}


// WEBPACK FOOTER //
// ./scripts/components/timeline.js